'use client'

import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { type CategoryDTO, Currency, type OldProductDTO, type Option } from 'ecosystem'
import { overrideText } from 'ui/lib/overrides'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { type CurrencyOverrides } from '../../types'
import useGoogleAnalytics from './use-google-analytics'

interface UseTrackProductViewProps {
  categories: Option<CategoryDTO[]>
  item: OldProductDTO
  currency: Currency
}

export const useTrackProductView = ({ item, categories, currency }: UseTrackProductViewProps) => {
  const GA = useGoogleAnalytics()
  const pathname = usePathname()
  const overrides = useOverridesContext<keyof CurrencyOverrides>()

  const isMounted = useRef(false)

  useEffect(() => {
    if (!isMounted.current && pathname) {
      GA.viewPdp(pathname)
      GA.viewItem(
        item,
        categories,
        overrideText(currency ?? Currency.SEK, overrides?.currency) as Currency
      )
      isMounted.current = true
    }
  }, [GA, categories, currency, item, overrides?.currency, pathname])
}
